import {DeviceClient, DmiApiClient, NotificationClient, NotificationSettingsClient, UserClient} from '../../api/api';
import {Client} from '../../api/api-dmi';

import {ApiBaseUrl, ApiDMI} from '../../utilities/constants';

export const deviceClient = new DeviceClient(ApiBaseUrl);
export const notificationClient = new NotificationClient(ApiBaseUrl);
export const notificationSettingsClient = new NotificationSettingsClient(ApiBaseUrl);
export const weatherClient = new Client(ApiDMI);
export const userClient = new UserClient(ApiBaseUrl);
export const dmiClient = new DmiApiClient(ApiBaseUrl);

export type ApiClient = DeviceClient | NotificationClient | NotificationSettingsClient | Client;
